const HtmlGenerator = (elements, styles) => `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <title>RP DATA</title>
        ${styles}
      </head>
      <body>
        ${elements}
      </body>
    </html>
`;

export default HtmlGenerator;
